"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectIndoorSessionsStatusFulfilled = exports.selectIndoorSessionsState = exports.selectIndoorSessionsPoints = exports.selectIndoorSessionsList = void 0;
const reselect_1 = require("reselect");
const selectIndoorSessionsState = (state) => state.indoorSessions;
exports.selectIndoorSessionsState = selectIndoorSessionsState;
const selectIndoorSessionsStatusFulfilled = (state) => state.indoorSessions.status === "FULFILLED" /* StatusEnum.Fulfilled */;
exports.selectIndoorSessionsStatusFulfilled = selectIndoorSessionsStatusFulfilled;
const selectIndoorSessionsPoints = (isDormant) => (0, reselect_1.createSelector)([selectIndoorSessionsState], (indoorSessionsState) => {
    const sessions = isDormant
        ? indoorSessionsState.dormantIndoorSessions
        : indoorSessionsState.activeIndoorSessions;
    return sessions.map(({ id, lastMeasurementValue, title, startTimeLocal, endTimeLocal, streams, lastHourlyAverageValue, }) => {
        var _a, _b, _c;
        const firstStream = streams[Object.keys(streams)[0]];
        let averageValue = null;
        if (firstStream &&
            ("average_value" in firstStream || "averageValue" in firstStream)) {
            averageValue =
                (_b = (_a = firstStream.average_value) !== null && _a !== void 0 ? _a : firstStream.averageValue) !== null && _b !== void 0 ? _b : null;
        }
        else {
            averageValue =
                (_c = lastHourlyAverageValue !== null && lastHourlyAverageValue !== void 0 ? lastHourlyAverageValue : lastMeasurementValue) !== null && _c !== void 0 ? _c : null;
        }
        return {
            id,
            title,
            sensorName: firstStream.sensorName,
            startTime: startTimeLocal,
            endTime: endTimeLocal,
            averageValue,
            lastMeasurementValue,
        };
    });
});
exports.selectIndoorSessionsPoints = selectIndoorSessionsPoints;
const selectIndoorSessionsList = (isDormant) => (0, reselect_1.createSelector)([
    (state) => isDormant
        ? state.indoorSessions.dormantIndoorSessions
        : state.indoorSessions.activeIndoorSessions,
], (sessions) => {
    return sessions.map(({ id, title, startTimeLocal, endTimeLocal, streams, lastHourlyAverageValue, lastMeasurementValue, }) => {
        var _a, _b, _c;
        const firstStream = streams[Object.keys(streams)[0]];
        let averageValue = null;
        if (firstStream &&
            ("average_value" in firstStream || "averageValue" in firstStream)) {
            averageValue =
                (_b = (_a = firstStream.average_value) !== null && _a !== void 0 ? _a : firstStream.averageValue) !== null && _b !== void 0 ? _b : null;
        }
        else {
            averageValue =
                (_c = lastHourlyAverageValue !== null && lastHourlyAverageValue !== void 0 ? lastHourlyAverageValue : lastMeasurementValue) !== null && _c !== void 0 ? _c : null;
        }
        return {
            id,
            title,
            sensorName: firstStream.sensorName,
            averageValue,
            startTime: startTimeLocal,
            endTime: endTimeLocal,
            streamId: firstStream.id,
        };
    });
});
exports.selectIndoorSessionsList = selectIndoorSessionsList;
